/**
 * Whether an error represents a cancelled/aborted HTTP request (not a real failure).
 *
 * axios rejects aborts (AbortController signal or CancelToken) as a `CanceledError`
 * with `code === 'ERR_CANCELED'`; native fetch uses a DOMException named `AbortError`.
 * Note: `axios.isCancel()` is unreliable once an error passes `httpService.handleError`,
 * because that handler re-wraps it via `{ ...error }` — a spread that drops the
 * `CanceledError` prototype (and its `__CANCEL__` marker) while preserving `name`/`code`.
 * Matching `name`/`code` therefore survives the re-wrap; `axios.isCancel` does not.
 *
 * @param {*} err
 * @returns {boolean}
 */
export function isAbortError(err) {
  return (
    err?.name === 'AbortError' ||
    err?.name === 'CanceledError' ||
    err?.code === 'ERR_CANCELED'
  );
}
